export const formatCount = (number: number) => {
  return new Intl.NumberFormat(window.navigator.language, {
    style: 'decimal',
  }).format(number);
};
